(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elkline-product-title"] && !Shopify.designMode) return;
  try {
    const splitElklineProductTitle = (fullTitle, productType) => {
    const cleanTitle = fullTitle.trim().replace(/\s+/g, ' ');
    const cleanType = productType.trim().replace(/\s+/g, ' ');

    if (!cleanTitle || !cleanType || cleanTitle.toLocaleLowerCase('de-DE') === cleanType.toLocaleLowerCase('de-DE')) return null;

    const titleCompare = cleanTitle.toLocaleLowerCase('de-DE');
    const typeCompare = cleanType.toLocaleLowerCase('de-DE');
    let name = cleanTitle;
    let displayType = cleanType;

    if (titleCompare.endsWith(typeCompare)) {
      name = cleanTitle.slice(0, cleanTitle.length - cleanType.length);
    } else {
      const middleStart = titleCompare.indexOf(` ${typeCompare} `);
      if (middleStart >= 0) {
        name = `${cleanTitle.slice(0, middleStart)} ${cleanTitle.slice(middleStart + cleanType.length + 2)}`;
      } else {
        const words = cleanTitle.split(' ');
        const typeStart = words.findIndex((word) => word !== word.toLocaleUpperCase('de-DE'));
        if (typeStart > 0) {
          name = words.slice(0, typeStart).join(' ');
          displayType = words.slice(typeStart).join(' ');
        }
      }
    }

    name = name.replace(/\s+/g, ' ').replace(/[\s\-–—|:]+$/u, '').trim();
    if (!name) return null;

    return { name, type: displayType, fullTitle: cleanTitle };
  };

  const enhanceElklineProductCardTitle = (card) => {
    const title = card.querySelector('.product-block__title');
    const productType = card.dataset.elkProductTypeLabel;

    if (!title || !productType) return;
    if (title.querySelector(':scope > .elkline-product-title__name')) return;

    const parts = splitElklineProductTitle(title.textContent, productType);
    if (!parts) return;

    const name = document.createElement('span');
    name.className = 'elkline-product-title__name';
    name.textContent = parts.name;

    const type = document.createElement('span');
    type.className = 'elkline-product-title__type';
    type.textContent = parts.type;

    title.replaceChildren(name, document.createTextNode(' '), type);
    title.classList.add('elkline-product-title');
  };

  const enhanceElklineProductTitles = (node) => {
    if (!(node instanceof Element)) return;

    const closestCard = node.matches('product-block') ? node : node.closest('product-block');
    if (closestCard) enhanceElklineProductCardTitle(closestCard);

    node.querySelectorAll('product-block').forEach(enhanceElklineProductCardTitle);
    node.querySelectorAll('.product-block__title').forEach((title) => {
      const card = title.closest('product-block');
      if (card) enhanceElklineProductCardTitle(card);
    });
  };

  document.querySelectorAll('product-block').forEach(enhanceElklineProductCardTitle);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(enhanceElklineProductTitles);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
